import withStyles from "react-jss"
import colors from "../../assets/colors"
import Navigation from "./Navigation"

const styles = {
  container: {
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    color: colors.white,
  },
  headerContainer: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "1140px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    padding: "0 1.5rem",
    margin: "40px auto 0 auto",
  },
  tag: {
    fontFamily: "WiredMono",
    fontSize: "11px",
    letterSpacing: "1.1px",
    lineHeight: "13px",
    textTransform: "uppercase",
    margin: "40px 0 16px 0",
    "@media only screen and (max-width: 768px)": {
      margin: "32px 0 16px 0",
    },
  },
  headline: {
    fontFamily: "Apercu, helvetica, sans-serif",
    fontSize: "46px",
    fontWeight: 700,
    letterSpacing: "-0.03px",
    lineHeight: "1em",
    margin: "0 0 32px 0",
    "@media only screen and (max-width: 1024px)": {
      fontSize: "43px",
      margin: "0 0 16px 0",
    },
    "@media only screen and (max-width: 768px)": {
      fontSize: "36px",
    },
  },
  dek: {
    fontFamily: "Apercu, helvetica, sans-serif",
    fontSize: "20px",
    fontWeight: 700,
    letterSpacing: "0.12px",
    margin: "0 0 32px 0",
  },
  tag2: {
    composes: "$tag",
    margin: "0 0 8px 0",
    "& a": {
      color: "white",
      textDecoration: "none",
    },
    "& a:hover": {
      textDecoration: "underline",
    },
  },
  figure: {
    boxSizing: "border-box",
    width: "100%",
    margin: "32px 0 0 0",
    "@media only screen and (max-width: 768px)": {
      fontSize: "36px",
      margin: "8px 0 0 0",
    },
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  caption: {
    margin: "8px auto",
    padding: "0 1.5rem",
    maxWidth: "1200px",
    fontFamily: "WiredMono",
    fontSize: "12px",
    color: "#999999",
    textTransform: "uppercase",
  },
}

const BG_IMAGE =
  "https://media.wired.com/photos/63ffba2f8320ec773f818fb5/16:9/w_1600/"

const Header = ({ classes }) => {
  return (
    <header className={classes.container}>
      <Navigation />
      <hgroup className={classes.headerContainer}>
        <h1 className={classes.headline}>Inside the Suspicion Machine</h1>
        <h2 className={classes.dek}>
          Obscure government algorithms are making life-changing decisions about
          millions of people around the world. Here, for the first time, we
          reveal how one of these systems works.
        </h2>
        <div className={classes.tag2}>
          {" "}
          <a href="https://www.wired.com/author/eva-constantaras/">
            Eva Constantaras
          </a>
          ,{" "}
          <a href="https://www.wired.com/author/gabriel-geiger/">
            Gabriel Geiger
          </a>
          ,{" "}
          <a href="https://www.wired.com/author/justin-casimir-braun/">
            Justin-Casimir Braun
          </a>
          ,{" "}
          <a href="https://www.wired.com/author/dhruv-mehrotra/">
            Dhruv Mehrotra
          </a>
          , <a href="https://www.wired.com/author/htet-aung/">Htet Aung</a>
        </div>
        <div className={classes.tag2}>MAR 6, 2023 7:00 AM</div>
      </hgroup>
      <figure className={classes.figure}>
        <img className={classes.img} src={BG_IMAGE} alt="Illustration of a man doing laundry with the shadow of two figures cast over him" />
        <figcaption className={classes.caption}>
          Illustration: Katherine Lam
        </figcaption>
      </figure>
    </header>
  )
}

export default withStyles(styles)(Header)
